export const zIndex = { base: 0, header: 10, drawer: 1200, modal: 1300, tooltip: 1500 } as const;
